import { render, staticRenderFns } from "./similar_properties.vue?vue&type=template&id=51870a47&scoped=true&"
import script from "./similar_properties.vue?vue&type=script&lang=js&"
export * from "./similar_properties.vue?vue&type=script&lang=js&"
import style0 from "./similar_properties.vue?vue&type=style&index=0&id=51870a47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51870a47",
  null
  
)

export default component.exports